import script from "./PaywallAdvantages.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallAdvantages.vue?vue&type=script&setup=true&lang=js"

import "./PaywallAdvantages.vue?vue&type=style&index=0&id=5482e49e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5482e49e"]])

export default __exports__